import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {StockApi, StockBase, StockCollection, StockHistoryCollection, StockListEbayCollection} from '../interfaces';
import { ApiService } from './api.service';

export type StockFilters = {
  etat?: string;
  note_min?: number;
  note_max?: number;
  prix_min?: number;
  prix_max?: number;
  quantite_min?:  number;
  quantite_max?: number;
  secteur_id?: string | number;
  produit_id?: string | number;
  etagere?: string;
  rayon?: string;
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    stocks?: string;
  }
  [x: string]: any;
}

export type StockListEbayFilters = {
    type?: 1 | 2 | 3
    prix_min?: number
    page?: number
    size?: number
}

@Injectable({
  providedIn: 'root'
})
export class StockService extends ApiService {

  public get(id: string | number, filters: StockFilters = {}): Observable<StockApi> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<StockApi>(`${this.apiUrl}/stocks/${id}${queryString}`)
  }

  public getCollection(filters: StockFilters = {}): Observable<StockCollection> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<StockCollection>(`${this.apiUrl}/stocks/${queryString}`)
  }

  public getListEbay(filters: StockListEbayFilters = {}): Observable<StockListEbayCollection> {
      const queryString = this.convertObjectToQueryString(filters)
      return this.http.get<StockListEbayCollection>(`${this.apiUrl}/stocks/a-lister-ebay${queryString}`)
  }

  public post(data: Partial<StockBase>, filters: StockFilters = {}): Observable<StockApi> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.post<StockApi>(`${this.apiUrl}/stocks/${queryString}`, data)
  }

  public patch(id: string | number, data: Partial<StockBase>, filters: StockFilters = {}): Observable<StockApi> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.patch<StockApi>(`${this.apiUrl}/stocks/${id}${queryString}`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/stocks/${id}`)
  }


    /**
     * Stock Historique APIs
     */

    public getStockHistoriqueCollection(filters: any = {}): Observable<StockHistoryCollection> {
        const queryString = this.convertObjectToQueryString(filters)
        return this.http.get<StockHistoryCollection>(`${this.apiUrl}/stock_historique/${queryString}`)
    }
}
